import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);

      if (!(date[0] && date[1] && date[2])) {
        return null;
      }

      return {
        day: parseInt(date[2], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[0], 10)
      };
    }

    return null;
  }

  // Date needs to be specifically formatted in ISO standard.
  format(date: NgbDateStruct): string {
    if (date) {
      return date.year.toString().padStart(4, '0') + this.DELIMITER +
        date.month.toString().padStart(2, '0') + this.DELIMITER +
        date.day.toString().padStart(2, '0');
    }

    return '';
  }
}
